import React from "react";
import { connect } from "react-redux";

// reactstrap components
import { Row, Container, Input, Button } from "reactstrap";

function Footer(props) {
  if(props.templates.templates) {
    const styleFooter = {
      background: `linear-gradient(${props.templates.templates.templateProperties.background_footer_first}, ${props.templates.templates.templateProperties.background_footer_second})` 
    }
    return (
      <div className="container-fluid p-0">
        <footer className="footer footer-black footer-white" style={styleFooter}>
          <Container>
            <Row>
              <div className="col-md-4 col-xs-4 text-center" style={{ padding:0 }}>
                  <img src="https://firebasestorage.googleapis.com/v0/b/tconcept-e8cbc.appspot.com/o/Light.png?alt=media&token=f3790a09-6a12-4139-831d-3526a7ffa01e" id="imageRegister" />
              </div>
              <div className="col-md-8 col-xs-8" style={{ padding:0 }}>
                  <div className="row justify-content-center">
                      <h3 style={{ fontSize:35 }} className="text-center"><i className="fa fa-envelope-square"></i></h3>
                      <div className="container row justify-content-center text-center" style={{ margin:"0 auto" }}>
                        <b style={{ fontSize:20 }}>Đăng ký và nhận ngay những ưu đãi hấp dẫn tại {props.templates.templates.templateProperties.store_name}!</b>
                      </div>
                      <hr style={{ backgroundColor:"lightgrey" }} />    
                      <div className="row justify-content-center webRegisterNotification">
                        <Input placeholder="Địa chỉ email..." type="email" style={{ width:320, marginRight:10 }} /> 
                        <Button className="btn btn-md btn-default o" id="registerMobile">Đăng ký</Button>
                      </div>
                      <div className="mobileRegisterNotification">
                        <div className="row justify-content-center">
                          <Input placeholder="Địa chỉ email..." type="email" style={{ width:320, marginRight:10 }} />
                        </div>
                        <div className="row justify-content-center" style={{ marginTop:"1%" }}>
                          <Button className="btn btn-md btn-default o" id="registerMobile">Đăng ký</Button>
                        </div>
                      </div>
                  </div>
              </div>
            </Row>
            <Row>
              <nav className="footer-nav">
                <ul>
                    <li><a href="https://www.facebook.com/nguyentu.299"><i className="fab fa-facebook-square"></i> Facebook</a></li>
                    <li><a href="https://www.instagram.com/thanhtunguyenn"><i className="fab fa-instagram-square"></i> Instagram</a></li>
                </ul>
              </nav>
              <div className="credits ml-auto">
                <span className="copyright" style={{ color:"#444444" }}>
                  © {new Date().getFullYear()}, made with{" "}
                  <i className="fa fa-heart heart" /> by Thanh Tu Nguyen
                </span>
              </div>
            </Row>
          </Container>
        </footer>
      </div>
    );
  }
  else {
    return(null)
  }
}

const mapStateToProps = (state) => {
  return {
    templates: state.templates,
  };
};

export default connect(mapStateToProps)(Footer);